<template>
  <div>
    <vx-card title="Edit Bidding Category" class="mb-base">
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">
          <div class="label-text">
            Category
          </div>
          <v-select
            class="inputx"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="Category"
            v-model="categoryModel"
            :options="category"
            label="categoryName"
            :reduce="(category) => category.id"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full">
          <div class="label-text">
            SubCategory
          </div>
          <v-select
            class="inputx"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="SubCategory"
            v-model="subCategoryModel"
            :options="subcategory"
            label="subCategoryName"
            :reduce="(subcategory) => subcategory.id"
          />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full mt-8">
          <vs-button @click="AddVendorCat">Add Category</vs-button>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/1 w-full"></div>
      </div>
    </vx-card>

    <vx-card title="Edit Bidding Category" class="mb-base">
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/1 sm:w-1/1 w-full">
          <vs-table
            search
            pagination
            max-items="5"
            :data="vendorCatListModel"
            :stripe="true"
            v-if="vendorCatListModel != null"
          >
            <template slot="thead">
              <vs-th sort-key="categoryName">Category</vs-th>
              <vs-th sort-key="subCategoryName">Sub Category</vs-th>
              <vs-th sort-key="delete">Action</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <!-- <vs-td :data="indextr">
                  {{ indextr }}
                </vs-td> -->
                <vs-td :data="data[indextr].categoryName">
                  {{ data[indextr].categoryName }}
                </vs-td>
                <vs-td :data="data[indextr].subCategoryName">
                  {{ data[indextr].subCategoryName }}
                </vs-td>
                <vs-td>
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="ml-2"
                    @click.stop="deleteCategory(tr.id)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <pre v-if="vendorCatListModel == null">No data Available.</pre>
        </div>
      </div>
      <vs-divider />
      <div class="vx-row mb-5">
        <div class="vx-col md:w-1/1 sm:w-3/4 w-full"></div>
        <div class="vx-col md:w-1/1 sm:w-1/4  w-full">
          <vs-button type="border" class="mb-2" @click="back">Close</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { _vendorservice } from "../../../services/vendorservices";
import { _masterservices } from "../../../services/masterservices";
export default {
  data() {
    return {
      category: [],
      subcategory: [],

      categoryModel: 0,
      subCategoryModel: 0,
      vendorCatListModel: [],

      id: 0,
    };
  },
  components: {
    "v-select": vSelect,
  },
  created() {
    this.getCategory();

    // Load vendor cat list
    this.getVendorCatList();
  },
  methods: {
    async getCategory() {
      this.category = await _masterservices.GetMasterCategories();
      // console.log(this.category);
    },
    async getSubcategory(id) {
      this.subcategory = await _masterservices.GetMasterSubCategoryById(id);
    },
    async getVendorCatList() {
      this.vendorCatListModel = await _vendorservice.GetVendorCategory(
        this.$route.params.username,
        0
      );
    },
    async AddVendorCat() {
      if (this.subCategoryModel != 0) {
        if (this.$route.params.username != "") {
          const model = {
            vendorId: parseInt(this.$route.params.id),
            userName: this.$route.params.username,
            categoryId: this.categoryModel,
            subCategoryId: this.subCategoryModel,
          };
          await _vendorservice.AddVendorCategory(model);
        } else {
          this.$vs.notify({
            title: "Can't add category!",
            text: "Please input TaxID before",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        }
      } else {
        this.$vs.notify({
          title: "Can't add category!",
          text: "Please select subcategory before",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      }

      // Load vendor category list
      this.getVendorCatList();
      // console.log(this.vendorCatListModel);
    },

    async deleteCategory(id) {
      this.id = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm delete`,
        text: `Are you sure to delete this category?`,
        accept: this.acceptAlert,
      });
    },
    acceptAlert: async function() {
      let result = await _vendorservice.DeleteVendorCategory(this.id);
      if (result) {
        this.$vs.notify({
          title: "Delete category!",
          text: "Delete category success",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "success",
        });

        // Load vendor category list
        this.getVendorCatList();
      }
    },
    back() {
      this.$router
        .push("/procurement-management/vendor/main/" + this.$route.params.id)
        .catch(() => {});
    },
  },
  watch: {
    // Bind subcategory options
    categoryModel() {
      // Clear subcategory value
      this.subCategoryModel = 0;
      this.getSubcategory(this.categoryModel);
    },
  },
};
</script>

<style>
.label-text {
  padding-bottom: 10px;
  color: #103a5d;
  font-weight: 500;
}
</style>
